import { GenericBanner } from "@/components/GenericBanner";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import animationData from "@/assets/animations/It_Works_Drawing_03_No_Loop.json";
import { JobSearchField } from "@/components/JobSearchField";

export default function Banner({ className, title, url_slug }) {
  return (
    <GenericBanner
      className={className}
      animationData={animationData}
      title={{
        path: `page.${url_slug}.case.study.banner.title`,
        placeholder: `<i>${title}</i> Case Study`,
      }}
    >
      <JobSearchField />
      <Breadcrumbs className="mt-md-5 pt-4" />
    </GenericBanner>
  );
}
